import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8b39fac0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-col justify-between items-center h-full" }
const _hoisted_2 = { class: "flex flex-col items-center h-full" }
const _hoisted_3 = { class: "flex justify-between align-center" }
const _hoisted_4 = { class: "flex flex-col items-center h-full" }

import { onMounted, onUnmounted, ref } from 'vue';

import AppIcon from '@/components/images/AppIcon.vue';
import AppLogo from '@/components/images/AppLogo.vue';
import useAlerts from '@/composables/useAlerts';
import useBreakpoints from '@/composables/useBreakpoints';
import useFathom from '@/composables/useFathom';

import AppNavActions from './AppNavActions.vue';
import AppNavAlert from './AppNavAlert.vue';
import DesktopLinks from './DesktopLinks/DesktopLinks.vue';

/**
 * STATE
 */

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const appNav = ref<HTMLDivElement>();

/**
 * COMPOSABLES
 */
const { bp, isDesktop, isMobile } = useBreakpoints();
const { trackGoal, Goals } = useFathom();
const { currentAlert } = useAlerts();

/**
 * METHODS
 */
function handleScroll() {
  if (!appNav.value) return;

  if (window.scrollY === 0) {
    appNav.value.classList.remove('shadow-lg');
  } else {
    appNav.value.classList.add('shadow-lg');
  }
}

/**
 * LIFECYCLE
 */
onMounted(() => {
  window.addEventListener('scroll', handleScroll);
});

onUnmounted(() => {
  window.removeEventListener('scroll', handleScroll);
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(currentAlert))
      ? (_openBlock(), _createBlock(AppNavAlert, {
          key: 0,
          alert: _unref(currentAlert)
        }, null, 8, ["alert"]))
      : _createCommentVNode("", true),
    (_unref(isDesktop))
      ? (_openBlock(), _createElementBlock("nav", {
          key: 1,
          id: "app-nav",
          ref: (_value, _refs) => {
            _refs['appNav'] = _value
            appNav.value = _value
          },
          class: "sticky top-0 h-20"
        }, [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_router_link, {
                to: { name: 'home' },
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(trackGoal)(_unref(Goals).ClickNavLogo)))
              }, {
                default: _withCtx(() => [
                  (['xs', 'sm'].includes(_unref(bp)))
                    ? (_openBlock(), _createBlock(AppIcon, { key: 0 }))
                    : (_openBlock(), _createBlock(AppLogo, { key: 1 }))
                ]),
                _: 1
              }),
              (_unref(isDesktop))
                ? (_openBlock(), _createBlock(DesktopLinks, {
                    key: 0,
                    class: "font-medium"
                  }))
                : _createCommentVNode("", true)
            ]),
            _createVNode(AppNavActions)
          ])
        ], 512))
      : _createCommentVNode("", true),
    (_unref(isMobile))
      ? (_openBlock(), _createElementBlock("nav", {
          key: 2,
          id: "app-nav-mobile",
          ref: (_value, _refs) => {
            _refs['appNavMobile'] = _value
          }
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_router_link, {
                to: { name: 'home' },
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(trackGoal)(_unref(Goals).ClickNavLogo)))
              }, {
                default: _withCtx(() => [
                  _createVNode(AppLogo)
                ]),
                _: 1
              })
            ]),
            _createVNode(AppNavActions)
          ])
        ], 512))
      : _createCommentVNode("", true)
  ], 64))
}
}

})